import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 gy-2" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Summary ", -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-text" }
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("h6", null, "Source Event", -1)
const _hoisted_14 = {
  key: 0,
  class: "card-text"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "col-md-6 gy-2"
}
const _hoisted_20 = { class: "card" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "Processing History", -1)
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "card-text" }
const _hoisted_24 = { class: "list-group list-group-flush" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("view template")
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Receiver links"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Source Event")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Receiver Event")
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-12 gy-2" }
const _hoisted_32 = { class: "card" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Signal Body ", -1)
const _hoisted_34 = {
  key: 0,
  class: "card-body"
}
const _hoisted_35 = { class: "card-text" }
const _hoisted_36 = { lang: "xml" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    (_ctx.signal.Generated)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", _hoisted_7, [
                  _createVNode("p", _hoisted_8, [
                    _createTextVNode(" Generated: " + _toDisplayString(_ctx.getHumanDate(_ctx.signal.Generated)), 1),
                    _hoisted_9,
                    _createTextVNode(" Conversion Status: " + _toDisplayString(_ctx.signal.ConversionStatus), 1),
                    _hoisted_10,
                    _createTextVNode(" Final status: " + _toDisplayString(_ctx.signal.State), 1),
                    _hoisted_11,
                    _createTextVNode(" Sequence: " + _toDisplayString(_ctx.signal.Sequence+1), 1),
                    _hoisted_12,
                    _createTextVNode(" Attempts: " + _toDisplayString(_ctx.signal.Attempts), 1)
                  ]),
                  _hoisted_13,
                  (_ctx.signal.CorrelationEvent)
                    ? (_openBlock(), _createBlock("p", _hoisted_14, [
                        _createTextVNode(" Timestamp: " + _toDisplayString(_ctx.getHumanDate(_ctx.signal.CorrelationEvent.SourceEvent.Timestamp)), 1),
                        _hoisted_15,
                        _createTextVNode(" Message: " + _toDisplayString(_ctx.signal.CorrelationEvent.SourceEvent.Message), 1),
                        _hoisted_16,
                        _createTextVNode(" Activity: " + _toDisplayString(_ctx.signal.CorrelationEvent.SourceEvent.Activity.ActivityType), 1),
                        _hoisted_17
                      ]))
                    : (_openBlock(), _createBlock("p", _hoisted_18, " Internal Event "))
                ])
              ])
            ]),
            (_ctx.signal.CorrelationEvent)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode("div", _hoisted_22, [
                      _createVNode("p", _hoisted_23, [
                        _createVNode("ul", _hoisted_24, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.signal.CorrelationEvent.ReceiverAction, (event, index) => {
                            return (_openBlock(), _createBlock("li", {
                              class: ["list-group-item", ['list-group-item', event.Result ? 'list-group-item-success' : 'list-group-item-danger']],
                              key: index
                            }, [
                              _createTextVNode(_toDisplayString(event.ReceiverStatus) + " @ " + _toDisplayString(_ctx.getHumanDate(event.Generated)) + " ", 1),
                              (event.TemplateId)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: '/receiver/template/' + event.TemplateId
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_25
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true),
                              (event.GeneratedArtefacts > 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_26, " " + _toDisplayString(event.GeneratedArtefacts) + " signals", 1))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ])
                      ]),
                      _createVNode("div", _hoisted_27, [
                        _createVNode(_component_router_link, {
                          to: '/sheqsy/event/'+_ctx.signal.CorrelationEvent.SourceEvent.id,
                          class: "btn btn-outline-primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _createVNode(_component_router_link, {
                          to: '/receiver/correlation/'+_ctx.signal.CorrelationEvent.id,
                          class: "btn btn-outline-primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                _hoisted_33,
                (_ctx.signal.Body)
                  ? (_openBlock(), _createBlock("div", _hoisted_34, [
                      _createVNode("p", _hoisted_35, [
                        _createVNode("pre", _hoisted_36, _toDisplayString(_ctx.formatXml(_ctx.signal.Body)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}